module.exports = __webpack_public_path__ + "media/src/assets/Images/MobileContactBackground-e9cce9b94c4c92eafd9266b1780e5463.svg";